import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "../hrmTour.css";

/**
 * Tour trang Chấm công HRM: tab Phiếu + (nếu có quyền) Xác nhận/Giải trình và tab Nhật ký.
 * @param {{ canAttendanceConfirm?: boolean; switchToTab?: (tab: "logs" | "confirmation" | "activity") => void }} [options]
 */
export function startAttendanceLogListTour(options = {}) {
  const { canAttendanceConfirm = false, switchToTab } = options || {};

  switchToTab?.("logs");

  const steps = [
    {
      popover: {
        title: "Chấm công HRM — các tab xác nhận/giải trình",
        description:
          "Tab «Phiếu chấm công»: vận hành chấm công hằng ngày. Khi có quyền đọc hrm.attendance.confirm: tab «Xác nhận / Giải trình» (gửi yêu cầu, hạn, giải trình, đóng kỳ) và tab «Nhật ký xác nhận / giải trình» (dòng sự kiện kỳ + giải trình + đồng ý bảng công). Tour bắt đầu từ tab phiếu; có quyền thì chuyển sang tab xác nhận ở cuối.",
        side: "over",
        align: "center",
      },
    },
  ];

  const logSegments = [
    [
      '[data-tour="hrm-attendance-header"]',
      "Tiêu đề trang",
      "Tên module chấm công; bên phải có ✨ Hướng dẫn nhanh (tour) và 📖 Hướng dẫn sử dụng (tài liệu quy trình đầy đủ).",
      "bottom",
    ],
    [
      '[data-tour="hrm-attendance-tabs"]',
      "Các tab xác nhận/giải trình",
      "«Phiếu chấm công»; «Xác nhận / Giải trình» (kỳ theo tháng); «Nhật ký xác nhận / giải trình» (sự kiện kỳ + giải trình + đồng ý).",
      "bottom",
    ],
    [
      '[data-tour="hrm-attendance-active"]',
      "Nhân sự đang check-in",
      "Danh sách nhân viên đang trong ca; có thể checkout giúp hoặc theo dõi nhanh.",
      "bottom",
    ],
    [
      '[data-tour="hrm-attendance-filter"]',
      "Bộ lọc & xuất dữ liệu",
      "Chọn khoảng ngày/chi nhánh, tạo phiếu (nếu được phép), xuất ma trận Excel theo tháng.",
      "bottom",
    ],
    [
      '[data-tour="hrm-attendance-chart"]',
      "Biểu đồ theo ngày",
      "So sánh số người làm việc hoặc số phiếu theo từng ngày trong khoảng lọc; hỗ trợ nhận diện ngày cao/thấp.",
      "top",
    ],
    [
      '[data-tour="hrm-attendance-table"]',
      "Bảng phiếu chấm công",
      "Chi tiết từng phiếu theo bộ lọc; mở phiếu để xem lộ trình GPS check-in/out.",
      "top",
    ],
  ];

  for (const [selector, title, description, side] of logSegments) {
    const el = document.querySelector(selector);
    if (!el) continue;
    steps.push({ element: el, popover: { title, description, side } });
  }

  if (canAttendanceConfirm) {
    steps.push({
      popover: {
        title: "Chuyển sang tab Xác nhận / Giải trình",
        description:
          "Bấm «Tiếp» để app chuyển sang tab đó. Các bước tiếp theo chỉ áp dụng khi tài khoản có quyền xem tab này.",
        side: "over",
        align: "center",
      },
      onHighlighted: (_element, _step, { driver }) => {
        switchToTab?.("confirmation");
        window.setTimeout(() => {
          try {
            driver.refresh();
          } catch {
            /* noop */
          }
        }, 150);
      },
    });

    const confirmSegments = [
      [
        '[data-tour="hrm-attendance-confirm-intro"]',
        "Kỳ bảng công & thao tác HCNS",
        "Chọn tháng áp dụng và làm mới. Khối màu cho biết kỳ đang mở hay đã đóng, đã gửi yêu cầu chưa, và thời điểm hết hạn nhận giải trình/xác nhận từ NV (do HCNS đặt khi gửi yêu cầu). Khối đỏ «HCNS»: gửi yêu cầu (bắt buộc có hạn), đóng kỳ, xuất Excel cho kế toán — theo quyền.",
        "bottom",
      ],
      [
        '[data-tour="hrm-attendance-confirm-sheet"]',
        "Phiếu của tôi trong tháng",
        "Bảng theo ngày: giờ vào/ra, đủ định vị/checkout, cột giải trình (lưu khi còn trong hạn và chưa xác nhận đồng ý tổng), và nút đồng ý tổng bảng công cho HCNS tổng kết. Sau khi hết hạn hoặc đã đồng ý tổng, app khóa chỉnh giải trình theo quy tắc hệ thống.",
        "top",
      ],
    ];

    /* Dùng selector chuỗi — driver resolve khi bước chạy (lúc đó tab xác nhận đã mount). */
    for (const [selector, title, description, side] of confirmSegments) {
      steps.push({ element: selector, popover: { title, description, side } });
    }
  }

  if (steps.length <= 1) {
    window.alert("Không tìm thấy vùng để chạy hướng dẫn.");
    return;
  }

  driver({
    showProgress: true,
    smoothScroll: true,
    popoverClass: "hrm-tour-popover",
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  }).drive();
}
